import { useNavigate } from 'react-router-dom';
import useTokenStore from '../stores/tokens';
import { PURPLE, MINT, hexToRgba } from '../utils/designUtils';

// 내 조직 관리 그룹
const MANAGE_TABS = [
  { key: 'org-info',     label: '조직 정보',  path: '/organization/info',      desc: '현재 소속된 조직의 기본 정보를 확인 및 수정합니다.' },
  { key: 'org-members',  label: '회원 목록',  path: '/employee/list',          desc: '조직에 속한 전체 회원을 조회하고 권한·승인 상태를 관리합니다.' },
  { key: 'org-settings', label: '조직 설정',  path: '/organization/settings',  desc: '직급·부서 등 조직 운영에 필요한 설정을 관리합니다. (MASTER 전용)' },
];
// 조직 생성·가입 그룹 (비회원 포함 누구나)
const JOIN_TABS = [
  { key: 'org-create', label: '조직 생성', path: '/organization/orgAdd', desc: '새로운 조직을 만들고 MASTER 권한으로 운영합니다.' },
  { key: 'org-join',   label: '조직 가입', path: '/organization/join',   desc: '조직 코드 또는 초대를 통해 다른 조직에 합류합니다.' },
];
const ALL_TABS = [...MANAGE_TABS, ...JOIN_TABS];

export default function OrgSectionTabs({ active }) {
  const navigate = useNavigate();
  const { user } = useTokenStore();
  const role = user?.currentRole;
  const approved = user?.currentOrganizationApproved;

  // 역할 노출 규칙: 회원목록=STAFF 제외+승인, 조직설정=MASTER만 (헤더 메뉴와 일치)
  // 접근 불가 탭은 숨기지 않고 비활성화 표시한다.
  const manageTabs = MANAGE_TABS.map((t) => {
    if (t.key === 'org-members') {
      if (role === 'STAFF') return { ...t, disabled: true, reason: '권한이 부족합니다' };
      if (!approved) return { ...t, disabled: true, reason: '조직 승인 후 이용할 수 있습니다.' };
    }
    if (t.key === 'org-settings' && role !== 'MASTER') {
      return { ...t, disabled: true, reason: '권한이 부족합니다' };
    }
    return t;
  });

  const cur = ALL_TABS.find((t) => t.key === active) || MANAGE_TABS[0];

  const PillGroup = ({ tabs }) => (
    <div style={{
      display: 'inline-flex', gap: 4, background: 'white', padding: 4, borderRadius: 12,
      border: '1px solid #ececf2', boxShadow: '0 1px 2px rgba(60,50,120,.04)',
    }}>
      {tabs.map((t) => {
        const isOn = t.key === active;
        const isDisabled = !!t.disabled;
        return (
          <button
            key={t.key}
            onClick={() => { if (!isDisabled) navigate(t.path); }}
            disabled={isDisabled}
            title={isDisabled ? t.reason : undefined}
            style={{
              height: 34, padding: '0 16px', borderRadius: 8, border: 'none',
              background: isOn ? `linear-gradient(135deg, ${PURPLE}, ${MINT})` : 'transparent',
              color: isDisabled ? '#c7c5d2' : (isOn ? 'white' : '#5d5b6e'),
              fontSize: 13, fontWeight: isOn ? 600 : 500,
              cursor: isDisabled ? 'not-allowed' : 'pointer', fontFamily: 'inherit',
              boxShadow: isOn ? `0 6px 14px -8px ${hexToRgba(PURPLE, .55)}` : 'none',
              opacity: isDisabled ? 0.55 : 1,
              transition: 'all 160ms', whiteSpace: 'nowrap',
              display: 'inline-flex', alignItems: 'center', gap: 5,
            }}>
            {isDisabled && (
              <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <rect x="5" y="11" width="14" height="10" rx="2" /><path d="M8 11V7a4 4 0 0 1 8 0v4" />
              </svg>
            )}
            {t.label}
          </button>
        );
      })}
    </div>
  );

  return (
    <div style={{ marginBottom: 20 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 6, fontSize: 12, color: '#8b8a99' }}>
        <span>조직</span>
        <svg width="11" height="11" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ transform: 'rotate(-90deg)' }}>
          <path d="M4 6l4 4 4-4" />
        </svg>
        <span style={{ color: '#3a3849', fontWeight: 500 }}>{cur.label}</span>
      </div>
      <h1 style={{ margin: 0, fontSize: 24, fontWeight: 700, color: '#1f1d2e', letterSpacing: '-0.01em' }}>
        {cur.label}
      </h1>
      <p style={{ margin: '4px 0 16px', fontSize: 13.5, color: '#7a7989' }}>{cur.desc}</p>

      <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', alignItems: 'center' }}>
        <PillGroup tabs={manageTabs} />
        <PillGroup tabs={JOIN_TABS} />
      </div>
    </div>
  );
}
